<template>
  <div>
    <Button v-if="!this" label="Hämta baseModel" class="grey" @click="fetchSlideList" /> 
		<SlideList :slideList="slideList" style="margin-top:0px;"/>
  </div>
</template>
<script>
import SlideList from "@/components/slide/SlideList.vue";
import { STORE_GETTER } from "../../store/store";
import { modelMixin } from "@/mixins/modelMixin.js";

export default {
  name: "SlideListWrapper",
  components: {
    SlideList
  },
	mixins: [modelMixin],
  data() {
    return {};
  },
  computed: {
    slideList() {


			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

      var list = baseModel?.slideList?.filter(slide => slide !== null && slide.type.includes("NYHETER"));

			if (!list){
				return [];
			}
			
      return list;

      
      /*return [
        {
          slideId: 0,
          title: "Slide A med bild",
          html: "text slide a",
          readMore: {
            href: "https://www.boove.se",
            label: "READ MORE HERE",
            target: "_blank"
          },
          imageList: [
            {
              src: "https://www.boove.se/testimage.jpg"
            }
          ],
          css: {
            backgroundImage: "url(http://public2.boove.se.dev2/images/www/bg_0.jpg)",
            backgroundSize: "cover"
          }
        },
        {
          slideId: 1,
          title: "Slide B",
          html: "text slide b",
          image1: "",
          css: {
            backgroundImage: "url(http://public2.boove.se.dev2/images/www/bg_4.jpg)",
            backgroundSize: "fill"
          }
        },
        {
          slideId: 2,
          title: "Slide C",
          html: "text slide c",
          css: {
            backgroundImage: "url(http://public2.boove.se.dev2/images/www/bg_3.jpg)",
            backgroundSize: "fill"
          }
        }
      ];*/
    }
  },

  methods: {
    fetchSlideList() {
			this.getBaseModel()
    }
  },
  mounted() {},
  unmounted() {}
};
</script>

<style scoped>
</style>